import { InjectionToken, signal } from '@angular/core';

export const ALARMS_SUBTITLE = new InjectionToken('alarm subtitle', {
  factory: () =>
    signal<{ key: string; params: Record<string, any> }>({
      key: '',
      params: {},
    }),
});
